import { string, func, number, bool, node, oneOf } from 'prop-types'
import React, { Children } from 'react'
import { AnalyticsLayer } from '@opallabs/quanta'
import { kuiperClassNames, kuiperClassNamesWithTracking } from '../utils'

import './styles.scss'

function getTabs(children, onChange, label, activeTab, valid) {
  const tabIndex = activeTab > -1 ? activeTab : 0

  const tabs = Children.toArray(children).map((child, i) => {
    if (!child.props.name) {
      console.warn('Tab buttons need a name prop to properly handle clicks.')
    }
    const props = {
      key: i,
      className: kuiperClassNames(
        { valid, active: tabIndex === i },
        'tab',
        child.props.className
      ),
      onClick: child.props.noclick
        ? null
        : onChange.bind(this, child.props.name),
    }

    const grandchildren = child.props.children
      ? Children.toArray(child.props.children)
      : null

    return React.cloneElement(child, props, grandchildren)
  })

  if (label) {
    return (
      <div className={kuiperClassNames('tab-section')}>
        <p className={kuiperClassNames('label')}>{label}</p>
        <div className={kuiperClassNames('tabs')}>{tabs}</div>
      </div>
    )
  }

  return <div className={kuiperClassNames('tabs')}>{tabs}</div>
}

const Tabs = ({
  activeTab = 0,
  children,
  className,
  label,
  onChange,
  theme = 'invisible',
  valid = false,
  name,
}) => (
  <AnalyticsLayer name={name || 'Tab Section'}>
    <div
      className={kuiperClassNamesWithTracking(
        'tab-section',
        className,
        `${theme}-theme`
      )}
    >
      {getTabs(children, onChange, label, activeTab, valid)}
    </div>
  </AnalyticsLayer>
)
Tabs.propTypes = {
  activeTab: number,
  children: node,
  className: string,
  label: string,
  name: string,
  onChange: func.isRequired,
  theme: oneOf(['switch', 'footer', 'invisible', 'dark']),
  valid: bool,
}

export default Tabs
